// Swym wishlist custom code (added here since we don't use a custom implementation)


// Utilised to make sure that the wishlist heart in the header nav is filled black if the user has an item in there wishlist
document.addEventListener('DOMContentLoaded', () => {
  function renderWishlistCounter(swat) {
    var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter")
    if (counter_elem) {
      for (var i = 0; i < counter_elem.length; i++) {
        if (swat.renderWishlistCount) {
          swat.renderWishlistCount(counter_elem[i]);
        }
      }
    }
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(renderWishlistCounter);

});

// Updates the wishlist count in the wishlist title (Utilises setInterval to wait for the wishlist grid to load in from Sywm)
document.addEventListener('DOMContentLoaded', () => {
  // Update the wishlist title count
  const updateWishlistCount = () => {
    const wishlistItemContainer = document.querySelector('.swym-wishlist-grid');
    const wishlistTitle = document.querySelector('.swym-wishlist-main-title.swym-heading');

    if (wishlistItemContainer && wishlistTitle) {
      const itemCount = wishlistItemContainer.querySelectorAll('li').length;

      if (itemCount > 0) {
        wishlistTitle.textContent = `${itemCount} ITEMS IN YOUR WISHLIST`;
        wishlistTitle.style.display = 'block';
      }
    } else {
      wishlistTitle.style.display = 'none';
    }
  };

  // Run the update function when the page loads
  if (window.location.pathname === '/pages/swym-wishlist') {
    const waitForWishlistGrid = setInterval(() => {
      const wishlistItemContainer = document.querySelector('.swym-wishlist-grid');
      const wishlistTitle = document.querySelector('.swym-wishlist-main-title.swym-heading');

      if (wishlistItemContainer && wishlistTitle) {
        updateWishlistCount();
        clearInterval(waitForWishlistGrid);

        const deleteButtons = document.querySelectorAll('.swym-delete-btn');
        deleteButtons.forEach((button) => {
          button.addEventListener('click', () => {
            // Add a delay to ensure DOM updates are complete
            setTimeout(updateWishlistCount, 1000);
          });
        });
      }
    }, 1000);
  }
});

// Custom code from SWYM support to refresh cart when item is added
function onSwymLoadCallback(swat) {
  let event = 'sw:addedtocart';
  let cartDrawer = document.querySelector('.cart-drawer');
  let listener = function (e) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
    }));

    cartDrawer.show();
    setTimeout(() => {
      cartDrawer.hide();
    }, 3000);
  };
  swat.evtLayer.addEventListener(event, listener);
}

if (window.location.pathname === '/pages/swym-wishlist') {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(onSwymLoadCallback);


  // Unhides wishlist container after 1.1 seconds to prevent photos resizing in front of the user
  setTimeout(() => {
    let wishlistContainer = document.querySelector('#swym-wishlist-container-render');
    if (wishlistContainer) {
      wishlistContainer.style.display = 'block';
    }
  }, 1100);


  // Custom code from the team at swym to make wishlist buttons disabled once the item is added to cart 
  function disableButtonIfAdded(button) {
    if (button.getAttribute('aria-label') === 'Item Added') {
      button.disabled = true;
    }
  }

  function observeButtons(container) {
    const buttons = container.querySelectorAll('button.swym-add-to-cart-btn.swym-button');

    buttons.forEach((button) => {
      disableButtonIfAdded(button);

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
            disableButtonIfAdded(mutation.target);
          }
        });
      });
      observer.observe(button, { attributes: true });
    });
  }

  // Runs with a timeout to wait for the wishlist grid to load / initialise 
  setTimeout(() => {
    const wishlistGrid = document.querySelector('ul.swym-wishlist-grid');
    if (wishlistGrid) {
      observeButtons(wishlistGrid);

      const parentObserver = new MutationObserver(() => {
        observeButtons(wishlistGrid);
      });

      parentObserver.observe(wishlistGrid, { childList: true, subtree: true });
    }
  }, 1500)
}

